import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=742583d4&scoped=true"
import script from "./StudentInformation.vue?vue&type=script&lang=js"
export * from "./StudentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742583d4",
  null
  
)

export default component.exports